<div class="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-8">

  <div class="max-w-md w-full space-y-5">

    <!-- Blurred Property Preview -->
    <div class="relative rounded-2xl overflow-hidden shadow-md">
      
      <!-- Image -->
      <img 
        src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
        class="w-full h-44 object-cover blur-sm scale-105"
      />

      <!-- Overlay -->
      <div class="absolute inset-0 bg-white/70 backdrop-blur-sm flex flex-col items-center justify-center text-center px-4">
        <p class="text-xs text-gray-500 mb-1">You’re trying to view</p>
        <p class="text-sm font-semibold text-gray-800">
          A curated property recommendation
        </p>
      </div>
    </div>

    <!-- Main Card -->
    <div class="bg-white rounded-2xl shadow-lg p-6 text-center">

      <!-- Icon -->
      <div class="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-red-100 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" 
             class="h-6 w-6 text-red-500" 
             fill="none" 
             viewBox="0 0 24 24" 
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M12 9v2m0 4h.01M5.455 19h13.09c1.1 0 1.79-1.2 1.25-2.13L13.25 4.87c-.55-.93-1.95-.93-2.5 0L4.2 16.87c-.54.93.15 2.13 1.25 2.13z"/>
        </svg>
      </div>

      <!-- Title -->
      <h2 class="text-xl font-semibold text-gray-800 mb-2">
        This link isn’t meant for this account
      </h2>

      <!-- Description -->
      <p class="text-gray-500 text-sm mb-4">
        This property link was curated specifically for another user.
      </p>

      <!-- Associated User -->
      <div class="bg-gray-50 border rounded-lg p-4 mb-3 text-left">
        <p class="text-xs text-gray-400 mb-2">Associated with</p>

        <div class="flex items-center gap-2 text-sm text-gray-700 mb-1">
          <span>📱</span>
          <span>{{ maskedPhone }}</span>
        </div>

        <div class="flex items-center gap-2 text-sm text-gray-700">
          <span>✉️</span>
          <span>{{ maskedEmail }}</span>
        </div>
      </div>

      <!-- Trust Microcopy -->
      <p class="text-[11px] text-gray-400 mb-5">
        For privacy reasons, curated links are personalized and cannot be accessed by other users.
      </p>

      <!-- Actions -->
      <div class="flex flex-col gap-3">

        <!-- Dynamic Primary CTA -->
        <button
          (click)="switchAccount()"
          class="w-full bg-black text-white px-5 py-3 sm:px-6 sm:py-3 rounded-xl sm:rounded-full shadow-lg sm:shadow-none flex items-center justify-center cursor-pointer">
          Switch Account
        </button>

        <!-- Login State -->
        <ng-template #loginBtn>
            <a
                (click)="goToLogin()"
                class="w-full px-5 py-3 flex items-center rounded-full gap-2 box-shadow-ff bg-white text-black transition cursor-pointer">
                Login to Continue
            </a>
        </ng-template>

        

        <!-- Tertiary -->
        <a
          routerLink="/customer-preference"
          class="text-sm text-gray-500 hover:text-gray-700 cursor-pointer">
          Request a Curated link
        </a>

      </div>
    </div>

  </div>
</div>